import { Anchor, AnchorWrapper, Section, StyledPanel, Title } from "../styled";
import React from "react";
import LatestCheckpointEvents from "./latestCheckpointEvents";
import useLatestCheckpoints from "../../../../hooks/useLatestCheckpoints";

export default function CheckpointEvents() {
  const { checkpoints, loading } = useLatestCheckpoints();

  return (
    <Section>
      <Title>Checkpoint Validation Events</Title>
      <StyledPanel>
        <LatestCheckpointEvents checkpoints={checkpoints} loading={loading} />
        <AnchorWrapper disabled={!checkpoints?.length || loading}>
          <Anchor to={"/events?section=checkpoint"}>
            View All Checkpoint Events
          </Anchor>
        </AnchorWrapper>
      </StyledPanel>
    </Section>
  );
}
